export enum AllowedTypes {
    PDF = 'application/pdf',
    JPG = 'image/jpeg',
    PNG = 'image/png'
}

export enum StatutResiliation {
    ENCOURS = 'ENCOURS',
    RESILIE = 'RESILIE',
    AUTORISE = 'AUTORISE'
}

export enum StatutRetractation {
    ENCOURS = 'ENCOURS',
    RETRACTE = 'RETRACTE',
    AUTORISE = 'AUTORISE'
}

export enum StatutStepAction {
    PAST = 'PAST',
    CURRENT = 'CURRENT',
    FUTUR = 'FUTUR'
}

export enum TypeStepAction {
    BUTTON = 'BUTTON',
    LINK = 'LINK'
}

export enum LabelStepAction {
    ANNULER = 'Annuler votre demande'
}

export enum StatutAnnulation {
    PRET = 0,
    ANNULE = 1
}
